import React, { FC } from 'react';
import { TContactSection } from '../../../../../../types/gdprConsentField.types';
import Icon from '../../../../../../../@shared/icon';
import { iconSize } from '../../../../../../../../constants/icon.constants';

const ContactSection: FC<TContactSection> = ({ contactChecboxes, updateData, textContent, data, disabled = false }) => {
  if (contactChecboxes.length === 0) return null;

  return (
    <div className={'gdpr-consent__contact-section' + (disabled ? ' gdpr-consent__contact-section--disabled' : '')}>
      <div className="gdpr-consent__contact-section-left">
        {contactChecboxes?.map((policy) => {
          const isChecked = !!(!disabled && data?.find((item) => item.id === policy.id)?.accepted);
          return (
            <label key={policy.id} htmlFor={policy.id.toString()}>
              <input
                id={policy.id.toString()}
                type="checkbox"
                required={policy.required}
                checked={isChecked}
                onChange={(e) => updateData(policy.id, e.target.checked)}
              />
              <Icon
                iconName={isChecked ? 'action-checkbox-checked' : 'action-checkbox-default'}
                size={iconSize.mbl}
                extraClassName="gdpr-consent__contact-section-icon "
              />
              <p>{policy.description}</p>
            </label>
          );
        })}
      </div>
      {textContent && (
        <div className="gdpr-consent__contact-section-right">
          <div className="gdpr-consent__radio-button-section-title">{textContent.title}</div>
          <div className="gdpr-consent__radio-button-section-desc">{textContent.description}</div>
        </div>
      )}
    </div>
  );
};

export default ContactSection;
